export type QuestionObjParams = {
  id: string;
  question: string;
  answer: string;
  approved?: boolean;
  number?: number;
  quizId?: string;
};

export class QuestionObj {
  id: string;
  question: string;
  answer: string;
  approved: boolean;
  number?: number;
  quizId?: string;

  constructor({
    id,
    question,
    answer,
    approved = false,
    number,
    quizId,
  }: QuestionObjParams) {
    this.id = id;
    this.question = question;
    this.answer = answer;
    this.approved = approved;
    this.number = number;
    this.quizId = quizId;
  }
}

export interface QuizObj {
  id: string;
  name: string;
  description: string;
  favourite: boolean;
  lastUpdated: Date;
}
